export default __webpack_public_path__ + "static/media/gy.5a571137.wav";